import TermsModal from 'components/Modal/TermsModal'
import React, { useState, useRef } from 'react'
import Modal from 'components/Modal/Modal'
import Loader from 'components/Loader'
import { POST } from 'api/request'
import * as urls from 'api/urls'

interface PaymentStatusResponse {
  result: order.Status
  error?: string
}

interface BlikModalProps {
  url: string
  getBody: (blik: string) => object
  callback?: (order_id?: string) => void
  onClose: base.BasicFunc
}

const DELAY = 3000

type Modals = 'privacy' | 'terms'

const errors: Record<string, string> = {
  WRONG_TICKET: 'Błędny kod!',
  TICKET_EXPIRED: 'Kod wygasł!',
  TICKET_USED: 'Kod został już wykorzystany!'
}

const BlikModal: React.FC<BlikModalProps> = ({ url, getBody, callback, onClose }) => {
  const [error, setError] = useState<string | boolean>(false)
  const [status, setStatus] = useState<order.Status>('INIT')
  const [modal, setModal] = useState<Modals | ''>('')
  const [blik, setBlik] = useState('')

  const orderResponse = useRef<order.OrderResponse | undefined>(undefined)
  const isPending = status === 'PENDING'

  const parsePaymentResponse = (result: order.Status, error?: string) => {
    if (result === 'SUCCESS') {
      onClose()
      callback?.(orderResponse.current?.data.id)
    } else if (result === 'FAILURE') {
      setStatus(result)
      setError(error || '')
      setBlik('')
    } else {
      setTimeout(checkPaymentStatus, DELAY)
    }
  }

  const validateForm = () => {
    if (blik.length === 6) {
      if (error) setError('')
      submit()
    } else {
      if (status !== 'INIT') setStatus('INIT')
      setError(true)
    }
  }

  const submit = async () => {
    setStatus('PENDING')
    try {
      const response = await POST<order.OrderResponse>(url, { body: getBody(blik) })
      if (response.ok) {
        orderResponse.current = response.data
        parsePaymentResponse(response.data.payment.status, response.data.payment.error)
      } else {
        setStatus('FAILURE')
      }
    } catch (err) {
      console.error(err)
    }
  }

  const checkPaymentStatus = async () => {
    try {
      const response = await POST<PaymentStatusResponse>(urls.paymentStatus, {
        body: {
          payment_id: orderResponse.current?.payment.payment_id
        }
      })
      if (response.ok) {
        parsePaymentResponse(response.data.result, response.data.error)
      }
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <>
      <Modal
        title='Blik'
        modalIsCoveredByAnotherModal
        primaryButton={isPending ? undefined : 'Wyślij'}
        primaryButtonAction={isPending ? undefined : validateForm}
        secondaryButton={isPending ? undefined : 'Anuluj'}
        secondaryButtonAction={isPending ? undefined : 'close'}
        onClose={onClose}>
        <div className='modal__blik'>
          {isPending
            ? <>
              <Loader type='full' />
              <div className='modal__blik__info'>
                <div>Potwierdź kod w aplikacji na telefonie</div>
              </div>
            </>
            : <>
              {status === 'FAILURE' && <div className='modal__blik__error'>
                <div>{typeof error === 'string' ? errors[error] : 'Wystąpił błąd podczas płatności.'}</div>
                <div>Wpisz ponownie kod</div>
              </div>}

              <div className='myInput'>
                <label className={error === true ? 'error' : undefined}>Wprowadź numer BLIK{error === true ? ` - 'Za mało znaków!'` : ''}</label>
                <div>
                  <input
                    type='tel'
                    className={error === true ? 'error' : undefined}
                    placeholder='Wpisz kod tutaj'
                    value={blik}
                    maxLength={6}
                    onChange={(e) => setBlik(e.target.value)} />
                  <i className='icon icon--blik'></i>
                </div>
              </div>
              <div className='desc'>
                Dokonując opłaty, akceptujesz <span onClick={() => { setModal('privacy') }}>regulamin</span> i naszą <span onClick={() => { setModal('terms') }}>politykę prywatności.</span>
              </div>
            </>}
        </div>
      </Modal>
      {modal && <TermsModal
        type={modal}
        onClose={() => {
          setModal('')
        }}
      />}
    </>
  )
}

export default BlikModal
